import React from "react";
import Chart from "react-apexcharts";

function KpkUnderTrialPrisonersInPakistan() {
  var options = {
    series: [
      {
        name: "",
        data: [33787, 13889, 11263, 1455],
      },
    ],
    chart: {
      height: 50,
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    colors: ["#0B2B42"],
    dataLabels: {
      style: {
        colors: ["#ffffff"],
      },
    },
    plotOptions: {
      bar: {
        barHeight: "80%",
        horizontal: true,
        dataLabels: {
          hideOverflowingLabels: true,
          position: "center",
        },
      },
    },
    xaxis: {
      categories: ["Punjab", "Sindh", "KP", "Balochistan"],
      labels: {
        style: {
          fontSize: "9px",
        },
      },
    },
    yaxis: {
      max: 35000,
      labels: {
        show: true,
        trim: false,
      },
    },
  };
  return (
    <div>
      <Chart
        options={options}
        series={options.series}
        type="bar"
        width="100%"
      />
    </div>
  );
}

export default KpkUnderTrialPrisonersInPakistan;
